import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  getRequestTypeStage,
  getRequestTypeDocs,
  getPhonePrevReqDetailsApi,
  prevPhoneStageDetailsApi,
  createPhoneRequestApi,
  createOtpRequest,
} from "designs/v1/pages/ModifyKyc/services";

const CheckPrevRequest = ({
  stageScreen,
  setStageScreen,
  setStep,
  setIsContinue,
  isLoading,
  setIsLoading,
  activeUserDetail,
  setPrevRequestInfo,
}) => {
  const [prevReqData, setPrevReqData] = useState({
    data: [],
  });
  const [checked, setChecked] = useState([]);
  useEffect(() => {
    const loadPrevPhoneReqInfo = async (requestList, requestType) => {
      setIsLoading(true);
      let payload = {
        request_type: requestType,
        client: activeUserDetail.client,
        pan_no: activeUserDetail.poi?.[0]?.pan_number,
        active_mobile_no: activeUserDetail.phone,
        active_kyc: activeUserDetail.name,
      };
      try {
        const resp = await getPhonePrevReqDetailsApi(payload);
        if (["PENDING", "INPROGRESS"].includes(resp.data?.data?.status)) {
          const data = resp.data.data;
          console.log("data", data);
          setIsLoading(false);
          setChecked((prev) => [
            ...prev,
            {
              requestType,
              mobile: data?.modification_mobile_number?.slice(2),
              email: data.modification_email,
            },
          ]);
          setPrevReqData((prev) => {
            return {
              ...data,
              data: [...prev.data, { title: requestType, ...data }],
            };
          });
          localStorage.setItem(
            requestType.split(" ")[0] + "RequestNumber",
            resp.data?.data?.rekyc_modi_request_name
          );
        } else {
          setPrevReqData((prev) => {
            return {
              ...prev,
              data: [...prev.data, { title: requestType }],
            };
          });
          requestList.push(requestType);
        }
      } catch (error) {
        console.log("err", error);
        setIsLoading(false);
      }
    };
    setPrevReqData({ data: [] });
    setPrevRequestInfo({
      phone: "",
      email: "",
    });
    const requestTypes = ["Mobile Modification", "Email Modification"];
    const requestList = [];
    const promises = requestTypes.map((element) =>
      loadPrevPhoneReqInfo(requestList, element)
    );
    Promise.all(promises)
      .then(() => {
        if (requestList.length === 2) {
          for (const [index, requestType] of requestList.entries()) {
            handleCreateRequest(requestList, requestType, index);
          }
        }
      })
      .catch((error) => {
        console.log("Error occurred:", error);
      });
  }, []);

  const handleCreateRequest = async (requestList, requestType, index) => {
    setIsLoading(true);
    const payload = {
      request_type: requestType,
      full_name: activeUserDetail.full_name,
      client: activeUserDetail.client,
      active_mobile_no: activeUserDetail.phone,
      active_email_id: activeUserDetail.email,
      active_pan: activeUserDetail.poi?.[0]?.pan_number,
      active_kyc: activeUserDetail.name,
      multiple_modification: 1,
      doctype_name: activeUserDetail.doctype,
      existing_customer: activeUserDetail.existing_customer,
      modification_type: "Modification",
    };
    try {
      const response = await createPhoneRequestApi(payload);
      if (!response.data?.data?.request_number) {
        return toast.error("Something went wrong, please try again");
      }
      setIsLoading(false);
      localStorage.setItem(
        requestType.split(" ")[0] + "RequestNumber",
        response.data?.data?.request_number
      );
      if (index === requestList.length - 1) {
        setStep("DematUccForm");
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const onSubmit = () => {
    let requestTypes = ["Mobile Modification", "Email Modification"];
    if (checked.length) {
      requestTypes = requestTypes.filter(
        (type) => !checked.map((type) => type.requestType).includes(type)
      );
    }
    if (!requestTypes.length) {
      const result = checked.reduce((acc, obj) => {
        if (obj.requestType === "Mobile Modification") {
          acc.mobile = obj.mobile;
        } else if (obj.requestType === "Email Modification") {
          acc.email = obj.email;
        }
        return acc;
      }, {});
      setPrevRequestInfo((prev) => ({
        ...prev,
        ...result,
      }));
      return setStep("DematUccForm");
    }
    for (const [index, requestType] of requestTypes.entries()) {
      const result = checked.reduce((acc, obj) => {
        if (obj.requestType === "Mobile Modification") {
          acc.mobile = obj.mobile;
        } else if (obj.requestType === "Email Modification") {
          acc.email = obj.email;
        }
        return acc;
      }, {});
      setPrevRequestInfo((prev) => ({
        ...prev,
        ...result,
      }));
      handleCreateRequest(requestTypes, requestType, index);
    }
  };

  return (
    <div>
      <Title title="Mobile and Email Modification Request" />
      <div className="col-md-12 mt-3">
        <div className="ml-2">
          {!!prevReqData.data.length && (
            <div>
              <div className="row mt-4">
                <h5 className="text-bold m-0">User Details</h5>
                <div className="row mt-1">
                  <div className="col-sm">Full Name</div>
                  <div className="col-sm">{prevReqData.full_name}</div>
                </div>
                <div className="row mt-1">
                  <div className="col-sm">Mobile Number</div>
                  <div className="col-sm">
                    {prevReqData.active_mobile_number?.slice(2)}
                  </div>
                </div>
                <div className="row mt-1">
                  <div className="col-sm">Email Address</div>
                  <div className="col-sm">{prevReqData.active_email}</div>
                </div>
                <div className="row mt-1">
                  <div className="col-sm">PAN Number</div>
                  <div className="col-sm">{prevReqData.active_pan_no}</div>
                </div>
              </div>

              {prevReqData.data.map((item) => (
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <div className="row mt-4">
                      <h5 className="text-bold m-0">{item?.title}</h5>
                      <div className="row mt-1">
                        <div className="col-sm">Request Type</div>
                        <div className="col-sm">
                          {item?.modification_request_type || "N/A"}
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-sm">Request Number</div>
                        <div className="col-sm">
                          {item?.rekyc_modi_request_name || "N/A"}
                        </div>
                      </div>
                      {item?.modification_request_type ===
                      "Mobile Modification" ? (
                        <div className="row mt-1">
                          <div className="col-sm">New Mobile Number</div>
                          <div className="col-sm">
                            {item?.modification_mobile_number?.slice(2) ||
                              "N/A"}
                          </div>
                        </div>
                      ) : (
                        <div className="row mt-1">
                          <div className="col-sm">New Email Address</div>
                          <div className="col-sm">
                            {item?.modification_email || "N/A"}
                          </div>
                        </div>
                      )}
                      <div className="row mt-1">
                        <div className="col-sm">Status</div>
                        <div className="col-sm">{item.status || "N/A"}</div>
                      </div>
                      {item?.modification_request_type && (
                        <div className="row mt-2">
                          <div className="col-sm">
                            Do you want continue with this request
                          </div>
                          <h6 className="col-sm">
                            <Form.Switch
                              name={item?.modification_request_type}
                              label={
                                checked
                                  .map((type) => type.requestType)
                                  .includes(item?.modification_request_type)
                                  ? "YES"
                                  : "NO"
                              }
                              checked={
                                checked
                                  .map((type) => type.requestType)
                                  .includes(item?.modification_request_type)
                                  ? true
                                  : false
                              }
                              onChange={({ target }) => {
                                if (target.checked) {
                                  setChecked((prev) => [
                                    ...prev,
                                    {
                                      requestType:
                                        item?.modification_request_type,
                                    },
                                  ]);
                                } else {
                                  setChecked((prev) =>
                                    prev.filter(
                                      (type) =>
                                        type.requestType !==
                                        item?.modification_request_type
                                    )
                                  );
                                }
                              }}
                              className="inherit"
                            />
                          </h6>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {!isLoading && (
            <div className="d-flex mt-4">
              <div className="">
                <Button
                  type="button"
                  title="Back"
                  handleClick={() => setStep("ActiveUserInfo")}
                  disabled={isLoading}
                />
              </div>
              <div className="mx-2">
                <Button
                  title="Continue"
                  handleClick={() => onSubmit()}
                  loading={isLoading}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckPrevRequest;
